import { render, staticRenderFns } from "./AddTraining.vue?vue&type=template&id=8f749fb8&scoped=true&"
import script from "./AddTraining.vue?vue&type=script&lang=js&"
export * from "./AddTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f749fb8",
  null
  
)

export default component.exports